import React, { useState, useRef, useEffect, useContext } from 'react'
import './snippetcontainer.scss'
import TrashIcon from '../../../shared/components/svgIcons/TrashIcon'
import api from '../../../api'
import { useParams } from 'react-router-dom'
import type { OpenTab } from '../WorkspaceContext'

import { WorkspaceContext } from '../WorkspaceContext'


const FileSettingPopup = ({ onClose }: { onClose: () => void }) => {

    const { roomId } = useParams()

    const ctx = useContext(WorkspaceContext);
    if (!ctx) throw new Error("Workspace must be wrapped in WorkspaceContext.Provider");

    const [deleteAssure, setDeleteAssure] = useState(false)

    const setInitialRole = () => {
        const role = ctx.memberDetails?.role;
        if (!role) return 'member';
        return role;
    }

    const [roleRef, setRoleRef] = useState<'owner' | 'admin' | 'member'>(setInitialRole());

    const tab = ctx.activeFile
    if (!tab) return null;




    function getTimeAgo(uploadedAt: string | Date) {
        const uploadedTime = new Date(uploadedAt).getTime();

        if (Number.isNaN(uploadedTime)) {
            return "Unknown";
        }

        const now = Date.now();
        const diffMs = now - uploadedTime;

        if (diffMs < 0) {
            return "Just now";
        }

        const diffMinutes = Math.floor(diffMs / (1000 * 60));
        const diffHours = Math.floor(diffMinutes / 60);
        const diffDays = Math.floor(diffHours / 24);
        const diffWeeks = Math.floor(diffDays / 7);
        const diffMonths = Math.floor(diffDays / 30);
        const diffYears = Math.floor(diffDays / 365);

        if (diffMinutes < 2) return "Just now";
        if (diffMinutes < 60) return `${diffMinutes} minutes ago`;
        if (diffHours < 24) return `${diffHours} ${diffHours === 1 ? "hour" : "hours"} ago`;
        if (diffDays < 7) return `${diffDays} ${diffDays === 1 ? "day" : "days"} ago`;
        if (diffWeeks < 4) return `${diffWeeks} ${diffWeeks === 1 ? "week" : "weeks"} ago`;
        if (diffMonths < 12) return `${diffMonths} ${diffMonths === 1 ? "month" : "months"} ago`;

        return `${diffYears} ${diffYears === 1 ? "year" : "years"} ago`;
    }







    const members = ctx.membersList;
    const clientId = ctx.clientId || localStorage.getItem("flashroom_id");

    const file = tab.resourceType === "file" ? tab.data : null;

    const ownerId = file?.uploaderClientId;

    const owner = members.find(m => m.clientId === ownerId);

    // const idx = ctx.openTabs.findIndex((tab) => {
    //     if (tab.resourceType !== "file") return false;
    //     return tab.data._id === file?._id;
    // });

    const idx = ctx.openTabs.findIndex((t) => t.data._id === file?._id);



    const canEditFile = () => {

        const me = members.find(m => m.clientId === clientId);
        const isRoomOwner =
            roleRef === "owner" ||
            ctx.memberDetails?.role === "owner" ||
            ctx.roomDetails?.creatorClientId === clientId;

        if (isRoomOwner) return true;
        if (!me) return false;
        if (ownerId === clientId) return true;
        if (roleRef === "admin" || ctx.memberDetails?.role === "admin") {

            if (
                owner?.role !== "admin" &&
                owner?.role !== "owner"
            ) {
                return true;
            }
        }
        return false;
    }


    const deleteFileClick = async () => {
        try {
            if (!canEditFile()) {
                ctx.setLimitMessage('You cannot delete this item');
                ctx.setLimitPopup(true);
                return;
            }
            await api.delete(`/rooms/${roomId}/${file?._id}/files`);
            onClose();

        } catch (error) {
            ctx.setLimitMessage('Could not delete file. Please try again.');
            ctx.setLimitPopup(true);
        }

    }
    return (
        <div id='file-setting-popup'>


            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h3>{file?.name}</h3>
                <button className='ns-cancel' onClick={onClose}>
                    <svg className="x-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 111.01 111.01">
                        <g id="Layer_3" data-name="Layer 3">
                            <path
                                className="cls-1"
                                d="M232.21,289.66a10.1,10.1,0,0,1-14.31,0l-38.22-38.22-38.23,38.23a10.13,10.13,0,0,1-14.32-14.32l38.23-38.23L127.14,198.9a10.12,10.12,0,1,1,14.31-14.31l38.22,38.22,38.23-38.23a10.13,10.13,0,0,1,14.32,14.32L194,237.13l38.22,38.22A10.12,10.12,0,0,1,232.21,289.66Z"
                                transform="translate(-124.17 -181.62)"
                            />
                        </g>
                    </svg>
                </button>
            </div>


            <br />
            <br />



            <div className='file-info' style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '10px' }}>
                {ctx.roomSettings.trackMembersEnabled && (
                    <div style={{
                        display: 'flex',
                        width: '50px',
                        height: '50px',
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: '50%', // or '9999px' if you like
                        backgroundColor: owner?.iconColor, // fallback color
                    }}>
                        <span className='m-i-c'>{owner?.name.slice(0, 1)}</span>
                    </div>
                )}

                <div className='uploaded-info'>
                    <div>
                        <h4>{ctx.roomSettings.trackMembersEnabled ? 'Uploaded By' : 'Uploaded'}</h4>
                        {ctx.roomSettings.trackMembersEnabled && (
                            <h5>{owner?.clientId === clientId ? 'you' : owner?.name}</h5>
                        )}

                    </div>
                    <h6>{
                        file?.createdAt ?
                            getTimeAgo(file?.createdAt) :
                            null} </h6>
                </div>


            </div>


            {canEditFile() &&
                <div className="snip-danger">
                    <button
                        onClick={() => setDeleteAssure(true)}
                        className="snip-danger-btn"

                    >
                        <TrashIcon />
                        <span>Delete File</span>
                    </button>
                </div>
            }





            {deleteAssure &&
                <div className='delete-assure'>
                    <h2>Are you Sure you want to delete this file</h2>

                    <div className='da-b'>
                        <button className='da-no' onClick={() => setDeleteAssure(false)}>No</button>
                        <button className='da-yes' onClick={deleteFileClick}>Yes</button>
                    </div>
                </div>
            }


        </div>
    )
}

export default FileSettingPopup
